import { useCallback, useEffect, useState } from "react";
import { getBrands } from "./requests";
import { DEFAULT_SORT } from "./constants";

export const useGetBrands = () => {
  const [brands, setBrands] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [filters, setFilters] = useState([]);
  const [currentSort, setCurrentSort] = useState(DEFAULT_SORT);
  const [currentPage, setCurrentPage] = useState(1);

  const updateFilters = useCallback(
    (changedFilterType, newFilterValue) => {
      const otherFilters = filters.filter(
        ({ filter_type }) => filter_type !== changedFilterType
      );
      const doResetFilter = newFilterValue === "";

      setFilters([
        ...otherFilters,
        ...(!doResetFilter
          ? [
              {
                filter_type: changedFilterType,
                filter: newFilterValue
              }
            ]
          : [])
      ]);
    },
    [filters]
  );

  const formatQuery = useCallback(() => {
    const filterList = filters.length
      ? filters.map(
          ({ filter_type, filter }) =>
            `${filter_type}=${encodeURIComponent(filter)}`
        )
      : [];
    const filterQuery = filterList.join("&");
    const sortQuery = `sort=${currentSort || DEFAULT_SORT}`;
    const pageQuery = `page=${currentPage}`;
    const query = `?${filterQuery}&${sortQuery}&${pageQuery}`;

    return query;
  }, [currentPage, currentSort, filters]);

  const getData = useCallback(async () => {
    try {
      const query = formatQuery();
      const { product_sources, total_results } = await getBrands(query);
      setTotalResults(total_results);
      setBrands(product_sources);
    } catch (error) {
      setBrands([]);
    }
  }, [formatQuery]);

  useEffect(() => {
    void getData();
  }, [getData]);

  return {
    brands,
    totalResults,
    currentPage,
    setCurrentPage,
    setCurrentSort,
    updateFilters
  };
};
